var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-form__section"},[_c('sk-note',{staticClass:"post-assignment__note",attrs:{"text":_vm.personalInfoWarning}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }